// SPDX-License-Identifier: AGPL-3.0-or-later

import {msg} from '@lingui/core/macro';
import {
	BellRingingIcon,
	FileIcon,
	ImageIcon,
	LinkIcon,
	PaletteIcon,
	SmileyIcon,
	SpeakerHighIcon,
	SquaresFourIcon,
	StickerIcon,
	TagIcon,
	VideoCameraIcon,
} from '@phosphor-icons/react';

export const PERK_DETAILS = {
	animated_icon: {
		Icon: ImageIcon,
		description: msg({
			message: 'Use an animated logo for your community.',
			comment: 'Explanation of the animated community icon perk.',
		}),
	},
	animated_banner: {
		Icon: ImageIcon,
		description: msg({
			message: 'Use an animated community banner.',
			comment: 'Explanation of the animated community banner perk.',
		}),
	},
	static_banner: {
		Icon: ImageIcon,
		description: msg({
			message: 'Static images are included without boosts.',
			comment: 'Explanation of free static community banner and invite background.',
		}),
	},
	video: {
		Icon: VideoCameraIcon,
		description: msg({
			message: 'In this community’s voice channels. Your personal video allowance still applies.',
			comment: 'Community video profile does not reduce personal streaming or camera rights.',
		}),
	},
	soundboard: {
		Icon: SpeakerHighIcon,
		description: msg({
			message: 'Total sounds in the community soundboard.',
			comment: 'Explanation of total community soundboard capacity.',
		}),
	},
	role_icons: {
		Icon: SmileyIcon,
		description: msg({
			message: 'Use Unicode or an emoji from this community as a role icon.',
			comment: 'Role icon perk accepts Unicode or same-community emoji only.',
		}),
	},
	role_gradient: {
		Icon: PaletteIcon,
		description: msg({
			message: 'Give roles a static gradient with two colors.',
			comment: 'Explanation of the static two-color role gradient perk.',
		}),
	},
	guild_tag: {
		Icon: TagIcon,
		description: msg({
			message: 'Members can show this community’s tag and badge beside their name.',
			comment: 'Explanation of the community tag perk; wearing it is each member’s own choice.',
		}),
	},
	guild_notification_sound: {
		Icon: BellRingingIcon,
		description: msg({
			message: 'Set a message sound for the community and its channels. Members can turn it off.',
			comment: 'Explanation of the community notification sound perk.',
		}),
	},
	guild_wallpaper: {
		Icon: ImageIcon,
		description: msg({
			message: 'Show a still image or a color behind messages in text channels.',
			comment: 'Explanation of the community wallpaper perk.',
		}),
	},
	file: {
		Icon: FileIcon,
		description: msg({
			message: 'Your personal upload allowance always applies.',
			comment: 'Community file rights never reduce personal upload rights.',
		}),
	},
	capacity: {
		Icon: SquaresFourIcon,
		description: msg({
			message: 'Total channels and roles available to this community.',
			comment: 'Explanation of total community channel and role capacities.',
		}),
	},
	bitrate: {
		Icon: SpeakerHighIcon,
		description: msg({
			message: 'Clearer audio in voice channels.',
			comment: 'Explanation of the community voice bitrate boost perk.',
		}),
	},
	emoji: {
		Icon: SmileyIcon,
		description: msg({
			message: 'More custom emoji for your community.',
			comment: 'Explanation of community emoji capacity boost perk.',
		}),
	},
	stickers: {
		Icon: StickerIcon,
		description: msg({
			message: 'More custom stickers for your community.',
			comment: 'Explanation of community sticker capacity boost perk.',
		}),
	},
	vanity_url: {
		Icon: LinkIcon,
		description: msg({
			message: 'Choose a memorable invite link.',
			comment: 'Explanation of the community vanity URL boost perk.',
		}),
	},
};
